export const CommonServiceCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Servizi',
    path: '/sistema/servizi',
  },
];
